import types from './types'
import modules from 'api/modules'

/**
 * Upsert modules
 * @param {Object} modules
 */
const upsert = (modules = {}) => ({
  type: types.upsert,
  modules,
})

const add = (moduleName, enabledModule = false) => {
  return async () => {
    return modules
      .addModule(moduleName, enabledModule)
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  }
}

const remove = (moduleName, enabledModule = false) => {
  return async () => {
    return modules
      .removeModule(moduleName, enabledModule)
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        return error
      })
  }
}

export default {
  upsert,
  add,
  remove,
}
